// Fuseau horaire officiel de la boutique : America/Montreal.
// RÈGLE PERMANENTE (ordre explicite du propriétaire, 2026-10-06 — mémoire long
// terme) : TOUTE heure affichée sur le site est à l'HEURE DE MONTRÉAL, été
// (UTC−4) comme hiver (UTC−5) — le fuseau gère le changement d'heure tout seul.
// Ne JAMAIS afficher un horodatage UTC brut (slice(0,16), slice(0,10)…).

const TZ = "America/Montreal";

const _parts = (d, opts) => Object.fromEntries(
  new Intl.DateTimeFormat("fr-CA", { timeZone: TZ, ...opts })
    .formatToParts(d)
    .filter((p) => p.type !== "literal")
    .map((p) => [p.type, p.value]));

// Un horodatage naïf (sans fuseau) est un UTC stocké en base → on le marque « Z »
const _parse = (iso) => {
  if (!iso) return null;
  let s = String(iso);
  if (!/Z$|[+-]\d{2}:?\d{2}$/.test(s)) s += "Z";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};

// « 2026-10-06 20:45 » — horodatage complet à l'heure de Montréal (historiques…)
export const fmtDateTimeMtl = (iso) => {
  const d = _parse(iso);
  if (!d) return "";
  const p = _parts(d, { year: "numeric", month: "2-digit", day: "2-digit",
                        hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
};

// « 2026-10-06 » — la DATE à Montréal d'un horodatage UTC (minuit UTC ≠ minuit ici)
export const fmtDateMtl = (iso) => {
  const d = _parse(iso);
  if (!d) return "";
  const p = _parts(d, { year: "numeric", month: "2-digit", day: "2-digit" });
  return `${p.year}-${p.month}-${p.day}`;
};

// Clé de jour AAAA-MM-JJ à Montréal pour un objet Date (« aujourd'hui », axes de graphiques)
export const dayKeyMtl = (d = new Date()) => {
  const p = _parts(d, { year: "numeric", month: "2-digit", day: "2-digit" });
  return `${p.year}-${p.month}-${p.day}`;
};

// Date longue localisée (« 6 octobre 2026 ») toujours à l'heure de Montréal
export const fmtDateMtlLong = (iso, lang = "fr-CA", opts = {}) => {
  const d = _parse(iso);
  return d ? d.toLocaleDateString(lang, { timeZone: TZ, ...opts }) : "";
};

// Date+heure localisées avec fuseau forcé (remplace toLocaleString sans timeZone)
export const fmtMtl = (iso, lang = "fr-CA", opts = {}) => {
  const d = _parse(iso);
  return d ? d.toLocaleString(lang, { timeZone: TZ, ...opts }) : "";
};

export const TZ_MONTREAL = TZ;
